export default "__VITE_ASSET__CY$cF7Wo__"